
function ImageReveal(){

    this.build();

}

ImageReveal.prototype.build = function(){

    let that = this;

    const elementItems = document.querySelectorAll(".project-view-more");
    elementItems.forEach(el => {
        el.addEventListener("mouseenter", that.mouseEnter.bind(this));
        el.addEventListener("mouseleave", that.mouseLeave.bind(this));
        el.addEventListener("mousemove", that.mouseMove.bind(this));
    });

};

ImageReveal.prototype.mouseMove = function(el){

    let fromTop = currentY + el.clientY - $(el.target).find('.hover-reveal').height() / 3;
    if( !currentY ){
        fromTop = el.clientY - $(el.target).find('.hover-reveal').height() / 3;
    }

    gsap.set( $(el.target).find('.hover-reveal') , {
        left: el.clientX + 20,
        top: fromTop
    });

};

ImageReveal.prototype.mouseEnter = function(el){

    let container = $(el.target).find('.hover-reveal');
    let inner = $(el.target).find('.hover-reveal__inner');
    let img = $(el.target).find('.hover-reveal__inner');

    gsap.killTweensOf( inner );
    gsap.killTweensOf( img );

    let tl = new gsap.timeline({
        onStart: function(){
            container.css('opacity',1);
        }
    });

    tl.add('start', 0.1);
    tl.fromTo( inner, 0.2 , {
        x: '-100%'
    },{
        x: '0%'
    }, 'start');
    tl.fromTo( img, 0.2 , {
        x: '100%'
    },{
        x: '0%'
    }, 'start');
};

ImageReveal.prototype.mouseLeave = function(el){

    let container = $(el.target).find('.hover-reveal');
    let inner = $(el.target).find('.hover-reveal__inner');
    let img = $(el.target).find('.hover-reveal__inner');

    gsap.killTweensOf( inner );
    gsap.killTweensOf( img );

    let tl = new gsap.timeline({
        onComplete: () => {
            container.css('opacity',0);
        }
    });

    tl.add('start');
    tl.fromTo( inner, 0.2 , {
        x: '0%'
    },{
        x: '100%'
    }, 'start');
    tl.fromTo( img, 0.2 , {
        x: '0%'
    },{
        x: '-100%'
    }, 'start');
};
